import {
  InventoryStatusEnum,
  Order,
  OrderAssetComponent,
  OrderAssetDelivery,
  OrderAssociatedParty,
  OrderItem,
  OrderModeStatus,
  OrderNetwork,
  OrderNetworkNode,
  OrderParty,
  OrderPartyRoleEnum,
  OrderState,
  OrderStatusEnum,
  OrderVehicle,
  Task,
  TaskModule,
} from "@/types";
import { PreconditionAction, PreconditionActionGemy, deepClone, globalConfig, sleep } from "@/utils";
import { addPartieToOrders, saveOrderOrch } from "@/store/services/order/orderOrch";
import {
  buildAlertList,
  buildOrderAlert,
  buildOrderAlertToDelete,
  calculateMargin,
  confirmBee2Link,
  getActeursEmailListOption,
  getAlertReasons,
  getAssignedUser,
  getAssociatedPartyInfo,
  getAssociatedPartymail,
  getDeletedDocumentsInfo,
  getDocumentsMove,
  getOrderAlertList,
  getOrderEditMode,
  getOrderParties,
  getOrderStatusProgress,
  getOrderTaskHistory,
  getPlaningEvent,
  getPlaningEventExport,
  getTypeScale,
  getUserTeamCdvSecretary,
  handelOrderDeletedDocuments,
  handleCommissionsRecalculate,
  handleOrderHistory,
  handleSubsidiesRecalculate,
  initOrderWorkflow,
  orderDuplicateMode,
  refreshCommission,
  saveOrderPlanning,
  searchAssetOrder, searchOrderByNumContract,
  setOrderActorContact,
  singingDocuments,
} from "@/store/services/order/orderService";
import { calculateProposalAsset, getAssetProduct } from "@/store/services/asset/assetMapper";
import { collectSignatureReceivedFileUids } from "@/commons/esign-signature";
import { convertAssetDeliveryModel, convertOrderVehicleToProductVehicle, convertProductAssetToOrderAsset, getOrderAssetServices, initOrders } from "@/store/services/order/orderMapper";
import {
  createOrderAlert,
  createOrderDeletedDocument,
  createProductCategoryClass,
  deleteOrder,
  deleteOrderAlert,
  getAllOrderDeletedDocuments,
  getInventoryItem,
  getOrder,
  getOrderAlert,
  getOrderItem,
  getOrderOrchestration,
  searchOrder,
  searchOrderDeliverySchedule,
  updateDateOrderItem,
  updateInventoryItem,
  updateOrderAlert,
  updateOrderItem,
  updateOrderStatus,
} from "@/store/services/order/orderApi";
import { formatDate } from "@/utils/configuration/formatters-config";
import { getAssetCustom, getCommercial, getNetwork, getNetworkNode, getPartyUser, getassetTax } from "@/store/services/offerService";
import { getGoodProposalItem, selectGoodImage } from "@/store/services/configuration/AssetService";
import {
  collectNewServiceTypes,
  collectNewSupplements,
  saveNewServiceTypes,
  saveNewSupplements,
  useCustomServiceType,
} from "@/store/services/order/orderNewValues";
import { sendMailICSWithDocument, sendMailWithDocument } from "@/store/services/order/sendMail";

import { Module } from "vuex";
import Notify from 'quasar/src/plugins/Notify.js';;
import { getAdditionalInformation, getOrderServiceType } from "@/store/services/picklist";
import { getProcess, normalizeSupportingType } from "./../../services/task/actions/uploadDocumentService";
import { getProductFeature } from "@/store/services/financing/product";
import i18n from "@/i18n";
import moment from "moment";
import orderFinancingModule from "@/store/modules/order/financing/orderFinancingModule";
import { refreshCommisions } from "@/store/services/order/commission/commissionService";
import router from "@/router";
import store from "@/store";
import { updateRecievedFile } from "@/commons/gathering-process";

export const orderChannel = new BroadcastChannel('order-sync');
export const orderModifications = new Map();
export const currentTabId = 'tab_' + Math.random().toString(36);

orderChannel.onmessage = (event) => {
  if (event.data.type === 'ORDER_MODIFIED') {
    orderModifications.set(event.data.resourceUid, {
      timestamp: event.data.timestamp,
      tabId: event.data.tabId
    });
  }
};

function toApiDate(value: any) {
  if (!value) return value;
  const parsed = moment(value, ["YYYY-MM-DD", "DD/MM/YYYY", moment.ISO_8601], true);
  return parsed.isValid() ? parsed.format("YYYY-MM-DD") : value;
}

function buildAlertDeletionTrace() {
  return {
    deletedBy: store.getters["authModule/getAuthName"],
    deletedAt: moment().format("YYYY-MM-DD HH:mm:ss"),
  };
}

const orderModule: Module<OrderState, any> = {
  namespaced: true,
  state: {
    mode: OrderModeStatus.CREATE,
    showAlert: false,
    showDocumentsHistory: false,
    showDeletedAlerts: false,
    showOts: false,
    checkValid: false,
    index: -1,
    orders: [],
    order: {},
    orderItem: {},
    preConditionDetailVisible: false,
    orderFinancingModule: {
      financing: {},
    },
    selectedAssetFrom: {},
    selectedProductAsset: {},
    tempSelectedOrderGoods: {},
    tempGoodOrderFilter: {},
    goodOrderFilter: {},
    selectedEventPlanning: {
      title: "",
      actionStartDate: "",
      actionStartHour: "",
      actionEndDate: "",
      actionEndHour: "",
      comment: "",
      clientName: "",
      range: "",
      brand: "",
      assetProduct: "",
      description: "",
      status_code: "",
      confirmed: false,
    },
    alertList: [],
    selectedOrdersAlertList: [],
    selectedOrdersAlertLoading: true,
    selectedSearchOrder: undefined,
    newParty: {},
    deliveryFilter: {},
    visibleColumns: [
      "status_code",
      "activity",
      "alert",
      "ots",
      "referenceOrder",
      "externalReference",
      "associatedpartyname",
      "finalclientname",
      "sellerName",
      "ordercreateddate",
      "orderdate",
      "initialdeliverydate",
      "brandRangeVersion",
      "chassis_reference",
      "registrationnumber",
      "DateRdvClient",
    ],
    defaultColumns: [
      "status_code",
      "activity",
      "alert",
      "ots",
      "referenceOrder",
      "externalReference",
      "associatedpartyname",
      "finalclientname",
      "sellerName",
      "ordercreateddate",
      "orderdate",
      "initialdeliverydate",
      "brandRangeVersion",
      "chassis_reference",
      "registrationnumber",
      "DateRdvClient",
    ],
    previousRoute: undefined,
    fromRoute: undefined,
    orderToDelivery: undefined,
    acteursEmailListOption: [],
    isSaving: false,
    deletedDocuments: [],
    // Hydrated preconditions (documents + actions) list for order
    gatheringProcessOrder: [],
    // Loading indicator for background hydration of documents + actions
    documentsActionsLoading: false,
  },
  getters: {
    getMode(state) {
      return state.mode;
    },
    isModeCreate(state) {
      return state.mode === OrderModeStatus.CREATE;
    },
    isModeEdit(state) {
      return state.mode === OrderModeStatus.EDIT;
    },
    getVisibleColumns(state) {
      return state.visibleColumns;
    },
    getDefaultColumns(state) {
      return state.defaultColumns;
    },
    getOderInit(): Order {
      return {
        reference: "",
        channel: "",
        previsionDeliveryDate: "",
        effectiveDeliveryDate: "",
        creationDate: "",
        assignedSalesPerson: "",

        orderParties: [store.getters["orderModule/getOrderAssociatedPartyInit"]],
        orderNetworks: store.getters["orderModule/getOrderNetworkInit"],
        orderNetworkNodes: store.getters["orderModule/getOrderNetworkNodeInit"],
        status: {
          resourceUid: OrderStatusEnum.ORDER,
          objectType: "odm.order.orderstatus",
        },
        orderItems: [store.getters["orderModule/getOrderItemInit"]],
        objectType: "odm.order.order",
        systemUid: "odm-order",
        alertList: [],
        orderSubsidies: [],
      };
    },
    getOrderAssociatedPartyInit(): OrderAssociatedParty {
      return {
        orderParty: store.getters["orderModule/getOrderPartyInit"],
        objectType: "odm.order.orderassociatedparty",
        systemUid: "odm-order",
      };
    },
    getOrderNetworkInit(): OrderNetwork {
      return {
        network: {
          objectType: "odm.party.network",
          systemUid: "odm-party",
        },
        objectType: "odm.order.ordernetwork",
        systemUid: "odm-order",
      };
    },
    getOrderNetworkNodeInit(): OrderNetworkNode {
      return {
        networkNode: {
          objectType: "odm.party.networknode",
          systemUid: "odm-party",
        },
        objectType: "odm.order.ordernetworknode",
        systemUid: "odm-order",
      };
    },
    getOrderItemInit(): OrderItem {
      return {
        reference: "",
        externalReference: "",
        initialDeliveryDate: "",
        previsionDeliveryDate: "",
        effectiveDeliveryDate: "",
        orderItemParent: null,
        type: {
          objectType: "odm.order.orderitemtype",
          systemUid: "odm-order",
          resourceUid: "CUSTOMER",
          //     TODO verify
        },
        status: {
          objectType: "odm.order.orderitemstatus",
          systemUid: "odm-order",
        },
        orderAssets: [store.getters["orderModule/getOrderAssetInit"], store.getters["orderModule/getOrderAssetInit"]],
        objectType: "odm.order.orderitem",
        systemUid: "odm-order",
      };
    },
    getOrderPartyInit(): OrderParty {
      return {
        party: {
          objectType: "odm.party.party.organization.frenchperson",
          systemUid: "odm-party",
        },
        role: {
          resourceUid: OrderPartyRoleEnum.CUSTOMER,
          objectType: "odm.order.orderpartyrole",
        },
        objectType: "odm.order.orderparty",
        systemUid: "odm-order",
      };
    },
    getAssetTradeInInit(): any {
      return {
        engagementAmount: {
          amount: 0.0,
          currency: "EUR",
        },
        overEstimationAmount: {
          amount: 0.0,
          currency: "EUR",
        },

        conversionBonus: {
          amount: 0.0,
          currency: "EUR",
        },
        origin: "",
        objectType: "odm.order.orderassettradein",
        systemUid: "odm-order",
        tradeInBalance: {
          amount: 0,
          currency: "EUR",
        },
        erAmountRetained: {
          amount: 0,
          currency: "EUR",
        },
        calculatedErAmount: {
          amount: 0,
          currency: "EUR",
        },
        totalFraisVO: {
          amount: 0,
          currency: "EUR",
        },
      };
    },

    getOrderAssetInit(): OrderVehicle {
      return {
        isFirstOwner: false,
        description: "",
        amountWoTax: {
          amount: 0,
          currency: "EUR",
        },
        bonus: {
          amount: 0,
          currency: "EUR",
        },
        tradeInCommitment: {
          amount: 0,
          currency: "EUR",
        },
        bbProvision: {
          amount: 0,
          currency: "EUR",
        },
        discountPercentage: 0,
        discountAmount: {
          amount: 0,
          currency: "EUR",
        },
        taxAmount: {
          amount: 0,
          currency: "EUR",
        },
        amountWTax: {
          amount: 0,
          currency: "EUR",
        },
        quantity: 0,
        totalAmountWoTax: {
          amount: 0,
          currency: "EUR",
        },
        totalTaxAmount: {
          amount: 0,
          currency: "EUR",
        },
        totalAmountWTax: {
          amount: 0,
          currency: "EUR",
        },
        purchaseAmountWoTax: {
          amount: 0,
          currency: "EUR",
        },
        purchaseAmountWTax: {
          amount: 0,
          currency: "EUR",
        },
        assetMargin: {
          amount: 0,
          currency: "EUR",
        },
        assetMarginRate: 0,
        cee: {
          amount: 0,
          currency: "EUR",
        },
        erAmountRetained: {
          amount: 0,
          currency: "EUR",
        },
        calculatedErAmount: {
          amount: 0,
          currency: "EUR",
        },
        totalFraisVO: {
          amount: 0,
          currency: "EUR",
        },
        assetProduct: undefined,
        packAssetProduct: undefined,
        assetTradeIn: store.getters["orderModule/getAssetTradeInInit"],
        supplier: store.getters["orderModule/getOrderPartyInit"],
        orderAssetComponents: [],
        orderAssetServices: [store.getters["orderModule/getOrderAssetServiceInit"]],
        assetDelivery: store.getters["orderModule/getOrderAssetDeliveryInit"],
        objectType: "odm.order.orderasset.ordergood.ordervehicle.ordercar",
        systemUid: "odm-order",
        flagNew: true,
        flagVD: false,
        nbOfCylinder: 0,
        nbOfGear: 0,
        taxHorsePower: 0,
        horsePower: 0,
        co2Emissions: 0,
        mineType: 0,
        fuelConsumptionUrban: 0,
        fuelConsumptionExtraUrban: 0,
        fuelConsumptionCombined: 0,
        brand: "",
        range: "",
        version: "",
        carBodyStyle: "",
        gearBox: "",
        engineType: "",
        matriculation: "",
        matriculationDate: "",
        chassisReference: "",
        constructionDate: "",
        currentMileage: 0,
        vehicleLength: "",
        color: "",
        firstCarRegistrationDate: "",
        insideColor: "",
        tvaValue: 0.0,
      };
    },

    getOrderAssetComponentInit(): any {
      return {
        config: {
          required: false,
          selected: true,
          selectModel: {
            label: "",
            id: "",
          },
          unitaryAmountModel: 0,
          amountWithTaxModel: 0,
          discountAmountModel: 0,
          taxValueModel: {
            label: "",
            id: "",
          },
          purchaseAmountWTaxModel: 0,
          purchaseAmountWoTaxModel: 0,
          reference: undefined,
        },
        type: {
          objectType: "odm.order.orderassetcomponenttype",
          systemUid: "odm-order",
        },
        label: "",
        amountWTax: {
          amount: 0,
          currency: "EUR",
        },
        discountPercentage: 0,
        discountAmount: {
          amount: 0,
          currency: "EUR",
        },
        taxAmount: {
          amount: 0,
          currency: "EUR",
        },
        amountWoTax: {
          amount: 0,
          currency: "EUR",
        },
        quantity: 1,
        totalAmountWoTax: {
          amount: 0,
          currency: "EUR",
        },
        totalTaxAmount: {
          amount: 0,
          currency: "EUR",
        },
        totalAmountWTax: {
          amount: 0,
          currency: "EUR",
        },
        objectType: "odm.order.orderassetcomponent",
        systemUid: "odm-order",
        tvaValue: 0.0,
      };
    },
    getOrderAssetServiceInit(): any {
      return {
        type: {
          objectType: "odm.order.orderassetservicetype",
          systemUid: "odm-order",
        },
        label: "",
        purchase: "false",
        duration: 0,
        mileage: 0,
        tvaValue: 0.0,
        activatedContract: false,
        amountWTax: {
          amount: 0,
          currency: "EUR",
        },
        amountWoTax: {
          amount: 0,
          currency: "EUR",
        },
        commissionAmount: {
          amount: 0,
          currency: "EUR",
        },
        purchaseAmountWTax: {
          amount: 0,
          currency: "EUR",
        },
        discountAmount: {
          amount: 0,
          currency: "EUR",
        },
        purchaseAmountWoTax: {
          amount: 0,
          currency: "EUR",
        },
        scaleCode: "",
        scaleLabel: "",
        objectType: "odm.order.orderassetservice",
        systemUid: "odm-order",
        optionMargin: 0,
      };
    },
    getOrderAssetDeliveryInit(): OrderAssetDelivery {
      return {
        deliveryDate: "",
        initialDeliveryDate: "",
        previsionDeliveryDate: "",
        effectiveDeliveryDate: "",
        deliveryAddress: {
          objectType: "",
          systemUid: "",
        },
        description: "",
        objectType: "odm.order.orderdeliverydetails",
        systemUid: "odm-order",
      };
    },
    getSelectedAssetFromInit() {
      return {};
    },
    getSlectedProductAssetInit() {
      return {};
    },
    getOrderReference(state) {
      return state.order?.reference;
    },
    getInitSelectedEventPlanning() {
      return {
        title: "",
        actionStartDate: "",
        actionStartHour: "",
        actionEndDate: "",
        actionEndHour: "",
        comment: "",
        confirmed: false,
      };
    },
    getIsSaving(state) {
      return state.isSaving;
    },
    getActeursEmailListOption(state) {
      return state.acteursEmailListOption;
    },
    getOrderAssetsTradeIn(state) {
        const orderAsset = state.order?.orderItems[0].orderAssets.find((a: any) => a.assetTradeIn !== null);
        if (!orderAsset) return null;
        return orderAsset;
    }
  },
  actions: {
    async initOrderEditMode({ commit, dispatch }, payload) {
      const { resourceUid } = payload;
      if (!resourceUid) {
        throw new Error("ResourceUid is mandatory!");
      }
      this.dispatch("taskModule/setModule", { module: TaskModule.ORDER });
      try {
        let order = await getOrderEditMode(resourceUid);
        const initialOrderItems = deepClone(order?.orderItems);
        const initialOrderConfig = deepClone(order?.config);
        order.config = { ...initialOrderConfig, initialOrderItems };
        commit("setOrder", order);
        const orderIdForAlerts = order?.resourceUid ?? resourceUid;
        if (orderIdForAlerts) {
          dispatch("getOrderAlertList", {
            filter: { orderId: orderIdForAlerts },
          });
        }
        store.dispatch("summaryPanelModule/setSummaryOrder", { order: order });
        const orderParties = await getOrderParties(order.orderParties);
        this.dispatch("orderPartyModule/setOrderParties", { orderParties: orderParties });

        const orderItems = await initOrders(order.orderItems);
        commit("setOrders", orderItems || []);
        const assetDeliveryModel = await convertAssetDeliveryModel(orderItems, order);
        commit("setAssetDeliveryModel", assetDeliveryModel);
        const associatedPartyInfo = getAssociatedPartyInfo(order, "order");
        commit("setAssociatedPartyInfo", associatedPartyInfo);
        const associatedPartymailList = getAssociatedPartymail(associatedPartyInfo);
        commit("setAssociatedPartymail", associatedPartymailList);
        store.dispatch("commandModule/setMode", "edit");
        const network = { value: order.orderNetworkNodes.networkNode.resourceUid.id, label: order.orderNetworkNodes.networkNode.resourceUid.id, config: { network_id: order.orderNetworks.network.resourceUid.id } };

        store.dispatch("authModule/setSelectedUserNetwork", {
          network: network,
        });

        //     TODO EF-202 review
      } catch (e: Error | any) {
        if (e instanceof Error && e.message === "order-not-found") {
          router.push("/order");
          Notify.create({
            message: i18n.global.t("order.messages.orderNotFound"),
            color: "negative",
          });
        } else {
          Notify.create({
            message: "ERROR: " + e,
            color: "negative",
          });
        }
      }
    },
    async refreshCommission({ commit }) {
      const order = await refreshCommisions();
      commit("setOrder", order);
    },
setAssociatedPartymail({ commit }, payload) {
      commit("setAssociatedPartymail", payload);
    },

    setOrderUpdate({ commit }, payload) {
      if (!payload || !payload.resourceUid) {
        throw new Error("orderId is mandatory");
      }
      commit("setOrder", payload);
    },
    toggleShow({ commit }) {
      commit("toggleShow");
    },
    toggleShowDocumentsHistory({ commit }) {
      commit("toggleShowDocumentsHistory");
    },
    toggleShowDeletedAlerts({ commit }) {
      commit("toggleShowDeletedAlerts");
    },
    toggleShowOts({ commit }) {
      commit("toggleShowOts");
    },
    deleteOrder({ commit }, payload) {
      const { resourceUid, onSuccess } = payload;
      deleteOrder(resourceUid)
        .then((res: any) => {
          Notify.create({
            message: i18n.global.t("order.messages.deleteSuccess"),
            color: "positive",
          });
          if (onSuccess) {
            onSuccess();
          }
        })
        .catch((err: any) => {
          console.error(err);
          Notify.create({
            message: err,
            color: "negative",
          });
        });
    },
    async deleteOrdersMass(_, payload) {
      const { ids, onSuccess } = payload;
      if (!Array.isArray(ids) || ids.length === 0) {
        return;
      }

      const results = await Promise.allSettled(
        ids.map((id: string) => deleteOrder(id))
      );

      const successCount = results.filter((result: any) => result.status === "fulfilled").length;
      const failedCount = results.length - successCount;

      if (successCount > 0) {
        Notify.create({
          message: `${successCount} dossier(s) supprimé(s) avec succès.`,
          color: "positive",
        });
      }

      if (failedCount > 0) {
        Notify.create({
          message: `${failedCount} suppression(s) en échec.`,
          color: "negative",
        });
      }

      if (successCount > 0 && onSuccess) {
        onSuccess();
      }
    },
    async orderDuplicateMode({ commit }, payload) {
      const { resourceUid, number, length, callback } = payload;
      if (!resourceUid) {
        throw new Error("ResourceUid is mandatory!");
      }
      this.dispatch("taskModule/setModule", { module: TaskModule.ORDER });
      try {
        const order = await orderDuplicateMode(resourceUid, number, length);
        if (callback) {
          callback(order.data);
        }
      } catch (e) {
        Notify.create({
          message: "ERROR: " + e,
          color: "negative",
        });
      }
    },

    initOrder({ commit, getters }, payload) {
      const order = getters.getOderInit;
      order.effectiveDeliveryDate = formatDate(new Date(), "/");
      this.dispatch("taskModule/setModule", { module: TaskModule.ORDER });
      commit("setOrder", order);
    },
    async initOrderItem({ commit, getters, state }, payload) {
      const { index, orderItem } = payload;
      commit("setIndex", index);
      const isCreateMode = !orderItem;
      const orderItemState: OrderItem = deepClone(isCreateMode ? getters.getOrderItemInit : orderItem);
      commit("setMode", isCreateMode ? OrderModeStatus.CREATE : OrderModeStatus.EDIT);
      if (!orderItemState || !orderItemState.orderAssets?.length || !(payload.index > -1)) {
        throw new Error("Invalid state initialization");
      }
      const orderAssets = orderItemState.orderAssets[0];
      const asset = await convertOrderVehicleToProductVehicle(orderAssets);
      orderItemState.orderAssets[0].config = asset.config;
      orderItemState.orderAssets[0].proposalAssetItems = asset.proposalAssetItems;
      commit("setOrderItem", orderItemState);
      commit("setAsset", asset);
      const newOrders: any = deepClone(state.orders);

      newOrders.push(orderItemState);
      commit("setOrders", newOrders);
    },
    async initOrderWorkflow({ state }, payload) {
      const { order } = state;
      const { callback, onMultipleTasks } = payload || {};
      try {
        await initOrderWorkflow(order);
        this.dispatch("taskModule/getFutureTaskByReferenceAndTaskDefinition", {
          orderReference: order.reference,
          taskDefinition: undefined,
          returnAll: true,
          onSuccess: async (tasks: Task[]) => {
            await this.dispatch("taskModule/setModule", { module: TaskModule.ORDER });
            await this.dispatch("releaseLockState");
            // Plusieurs taches en attente : l'utilisateur choisit celle a prendre en charge
            if (tasks.length > 1 && onMultipleTasks) {
              if (callback) callback();
              onMultipleTasks(tasks);
              return;
            }
            const task = tasks[0];
            if (task.assignee) {
              await this.dispatch("taskModule/unclaimOwnership", { task: task }).then((res: any) => {
                this.dispatch("taskModule/claimOwnership", { task, callback, blockRedirection: false });
              });
            } else {
              await this.dispatch("taskModule/claimOwnership", { task, callback, blockRedirection: false });
            }
          },
          onFail: async () => {
            await this.dispatch("releaseLockState");
            await this.dispatch("taskModule/getTasks");
            if (callback) callback();
            await router.push("/task/list");
          },
        });
      } catch (e: any) {
        Notify.create({
          message: e.message || e,
          color: "negative",
        });
      }
    },
    saveOrder({ state, dispatch }, payload) {
      const { order, orders } = state;
      const { orderParties } = payload;
      const modification = orderModifications.get(order.resourceUid);
      if (modification && modification.tabId !== currentTabId) {
        Notify.create({
          message: i18n.global.t("order.messages.modifiedInOtherTab"),
          color: "negative",
        });
        dispatch("initOrderEditMode", {
          resourceUid: order.resourceUid,
        });

        return;
      }
      order.orderItems = orders;
      // Values typed by the user, saved in the reference tables for the next orders.
      // Read before the save, which drops the "typed-in" flags.
      const newSupplements = collectNewSupplements(orders);
      const newServiceTypes = collectNewServiceTypes(orders);
      store.dispatch("orderModule/setIsSaving", true);
      // The services reference their type: new types are created before the order
      saveNewServiceTypes(newServiceTypes)
        .then((failedServiceTypes) => {
          useCustomServiceType(orders, failedServiceTypes);
          if (newServiceTypes.length > failedServiceTypes.length) {
            getOrderServiceType().then((res) => ((store.state as any).picklistModule.orderServiceType = res));
          }
          return saveOrderOrch(order, orderParties).then((res: any) => ({ res, failedServiceTypes }));
        })
        .then(({ res, failedServiceTypes }: any) => {
          if (payload && payload.callback) {
            payload.callback(res);
          }
          store.dispatch("orderModule/setIsSaving", false);
          if (res?.resourceUid) {
            saveNewSupplements(newSupplements).then((failedSupplements) => {
              const failed = [
                ...newServiceTypes.filter((item) => failedServiceTypes.includes(item.code)).map((item) => item.label),
                ...failedSupplements,
              ];
              if (failed.length > 0) {
                Notify.create({
                  message: i18n.global.t("order.messages.newValuesSaveError", { labels: failed.join(", ") }),
                  color: "warning",
                });
              }
            });
          }
          if (res?.resourceUid) {
            orderChannel.postMessage({
              type: 'ORDER_MODIFIED',
              resourceUid: res.resourceUid,
              timestamp: Date.now(),
              tabId: currentTabId
            });
            Notify.create({
              message: i18n.global.t("order.messages.createSuccess"),
              color: "positive",
            });
            if (state.checkChangeProposal) {
              Notify.create({
                message: i18n.global.t("order.messages.refreshCommissions"),
                color: "warning",
                timeout: 20000,
              });
            }
            dispatch("initOrderEditMode", {
              resourceUid: res.resourceUid,
            }).then(() => {
              // On save, re-evaluate field/BR checkpoints against the saved order (reevaluate=true),
              // then the same hydration renders the freshly-created checkpoints. Plain reloads do not.
              dispatch("hydrateDocumentsAndActions", { reevaluate: true });
            });
          }
        })
        .catch((err: any) => {
          store.dispatch("orderModule/setIsSaving", false);
        });
    },
    calculateMargin({ state }, payload) {
      const { order, orders } = state;
      order.orderItems = orders;
      calculateMargin(state.order).then((res: any) => {
        if (payload && payload.callback) {
          payload.callback(res);
        }
      });
    },
    async fetchUser() {
      return getPartyUser();
    },
    network({ commit }, payload) {
      const { filter, callback, orderNetworkNodes } = payload;
      getNetwork(filter)
        .then((res) => {
          if (res.items.length > 0) {
            commit("setNetwork", res.items[0]);
            callback(res);
          }
        })
        .catch((e) => console.error(e));
    },
    searchAssetOrder({ commit }, payload) {
      const { filter, callback } = payload;
      searchAssetOrder(filter)
        .then((res) => {
          callback(res);
        })
        .catch((e) => console.error(e));
    },
    async getPlaningEvent({ commit }, payload) {
      const { callback, filter } = payload;
      const res = await getPlaningEvent(filter);
      commit("setPlaningEvent", res);
      callback(res);
    },
    async getPlaningEventExport({ commit }, payload) {
      const { callback, filter } = payload;
      const res = await getPlaningEventExport(filter);

      callback(res);
    },
    setPlaningEvent({ commit }, payload) {
      commit("setPlaningEvent", payload);
    },
    setPlanningNoActorFilter({ commit }, payload) {
      commit("setPlanningNoActorFilter", payload);
    },
    selectedDayEvent({ commit }, payload) {
      commit("selectedDayEvent", payload);
    },
    changeDateEvent({ commit }, payload) {
      commit("changeDateEvent", payload);
    },

    initSelectedEventPlanning({ commit, getters }) {
      const selectedEventPlanning = getters.getInitSelectedEventPlanning;
      commit("setSelectedEventPlanning", selectedEventPlanning);
    },
    setSelectedEventPlanning({ commit }, payload) {
      commit("setSelectedEventPlanning", payload);
    },
    setSelectedEventPlanningAssignedUser({ commit }, payload) {
      commit("setSelectedEventPlanningAssignedUser", payload);
    },
    commercial({ commit }, payload) {
      const { filter, callback } = payload;
      getCommercial(filter)
        .then((res) => {
          if (res.items.length == 1) {
            commit("setCommercial", res.items[0]);
          }
          if (callback) {
            callback(res);
          }
        })
        .catch((e) => console.error(e));
    },

    networkNode({ commit }, payload) {
      const { filter, callback, selectedUserNetwork } = payload;
      getNetworkNode(filter)
        .then((res) => {
          if (res.items.length == 1) {
            commit("setNetworkNode", res.items[0]);
          } else if (selectedUserNetwork) {
            commit("setNetworkNode", selectedUserNetwork);
          }

          callback(res);
        })
        .catch((e) => console.error(e));
    },

    setOrderAssociatedParty({ commit }, payload) {
      commit("setOrderAssociatedParty", payload);
    },
    setChannel({ commit }, payload) {
      commit("setChannel", payload);
    },
    setSupplier({ commit }, payload) {
      commit("setSupplier", payload);
    },
    async createOrderAlert({ state, commit }, payload) {
      const { orderId, comment, reasons, recipients } = payload;
      const orderAlert = await buildOrderAlert(comment, reasons, recipients);
      if (orderAlert) {
        const createdAled = await createOrderAlert(orderAlert, orderId);
        commit("addOrderAlert", { orderId, alert: createdAled?.data });
        await sleep(250);
        const filter = {
          orderId: orderId,
        };
        const list = await getOrderAlertList(filter);
        const alertList = buildAlertList(list);
        Notify.create({
          message: "Order Alert created...",
          color: "positive",
        });

        commit("setOrderAlertList", alertList);
      }
    },
    updateOrderAlert({ state, commit }, payload) {
      const { alertId, alert } = payload;
      updateOrderAlert(alert, alertId)
        .then((res) => {
          Notify.create({
            message: "Order Alert updated...",
            color: "positive",
          });
        })
        .catch((e) => console.error(e));
    },
    async orderAlertDelete({ state, commit }, payload) {
      const { alertId } = payload;
      const orderAlert: any = await getOrderAlert(alertId);
      orderAlert.alertValidity.from = toApiDate(orderAlert.alertValidity.from);
      orderAlert.alertValidity.until = moment(new Date()).format("YYYY-MM-DD");
      const deletion = buildAlertDeletionTrace();
      orderAlert.businessData = { ...(orderAlert.businessData || {}), ...deletion };
      await updateOrderAlert(orderAlert, alertId)
        .then((res) => {
          commit("closeOrderAlert", { alertId, ...deletion });
          Notify.create({
            message: "Order Alert updated...",
            color: "positive",
          });
        })
        .catch((e) => console.error(e));

    },
    async deleteOrderAlert({ state, commit }, payload) {
      const { alert, orderId, alertId } = payload;
      const orderAlert: any = buildOrderAlertToDelete(payload, alertId, alert.comment, alert.reasons);
      const deletion = buildAlertDeletionTrace();
      const current: any = await getOrderAlert(alertId);
      orderAlert.createdBy = current?.createdBy;
      orderAlert.createdAt = current?.createdAt;
      orderAlert.businessData = { ...(current?.businessData || {}), ...deletion };
      orderAlert.alertValidity.from = toApiDate(current?.alertValidity?.from ?? orderAlert.alertValidity.from);
      orderAlert.alertValidity.until = toApiDate(orderAlert.alertValidity.until);
      await updateOrderAlert(orderAlert, alertId);
      commit("closeOrderAlert", { alertId, ...deletion });

      await sleep(250);
      const filter = {
        orderId: orderId,
      };
      const list = await getOrderAlertList(filter);

      const alertList = buildAlertList(list);

      Notify.create({
        message: "Order Alert deleted...",
        color: "positive",
      });

      commit("setOrderAlertList", alertList);
    },
    setorderSubvention({ state, commit }, payload) {
      if (state.order?.orderSubsidies) {
        const oldorderSubventiont = state.order.orderSubsidies;
        oldorderSubventiont.unshift(payload);
        commit("setorderSubvention", oldorderSubventiont);
      } else {
        commit("setorderSubvention", [payload]);
      }
    },
    async insertOrderItem({ state, commit }) {
      const { orderItem, asset, order } = state;
      const orderAssetServices = getOrderAssetServices(orderItem.orderAssets[0].orderAssetServices);
      orderItem.orderAssets[0] = convertProductAssetToOrderAsset(asset, orderItem);
      orderItem.orderAssets[0].orderAssetServices = orderAssetServices;
      store.state.orderModule.tempSelectedOrderGoods && store.state.orderModule.tempSelectedOrderGoods.inventory_item_code
        ? (orderItem.orderAssets[0].inventoryItemCode = store.state.orderModule.tempSelectedOrderGoods.inventory_item_code)
        : null;
      const newOrders: any = deepClone(state.orders);
      newOrders.push(orderItem);
      commit("setOrders", newOrders);

      const assetDeliveryModel = await convertAssetDeliveryModel(newOrders, order);
      commit("setAssetDeliveryModel", assetDeliveryModel);
    },
    async editOrderItem({ state, commit }) {
      const { index, orderItem, asset, order } = state;
      const newOrders: any = deepClone(state.orders);
      const orderAssetServices = getOrderAssetServices(orderItem.orderAssets[0].orderAssetServices);
      orderItem.orderAssets[0] = convertProductAssetToOrderAsset(asset, orderItem);
      orderItem.orderAssets[0].orderAssetServices = orderAssetServices;
      newOrders[index] = orderItem;
      commit("setOrders", newOrders);

      const assetDeliveryModel = await convertAssetDeliveryModel(newOrders, order);
      commit("setAssetDeliveryModel", assetDeliveryModel);
    },
    deleteOrderItem({ state, commit }, payload) {
      const { index, inventoryItemCode } = payload;
      const orderToRemove = state.orders[index];
      if (inventoryItemCode) {
        this.dispatch("orderModule/updateInventoryItem", {
          inventoryItemCode: inventoryItemCode,
          status: InventoryStatusEnum.IN_STOCK,
        });
      }
      const newOrders: any = deepClone(state.orders.filter((order: any) => order !== orderToRemove));
      commit("setOrders", newOrders);
    },
    searchAsset({ commit, state }, payload) {
      const { id, category, refreshAssetItems, index, productName } = payload;
      const { orders, order } = state;
      const proposalAsset = state.orders[index].orderAssets[0];
      const assetDeliveryModel = deepClone(proposalAsset.config.assetDeliveryModel);
      const supplier = deepClone(proposalAsset.config.formBind.supplier);
      if (id && proposalAsset) {
        getAssetProduct(id, proposalAsset, category, refreshAssetItems)
          .then(async (res) => {
            res.config.assetDeliveryModel = assetDeliveryModel;
            res.config.formBind.supplier = supplier;
            res.config.supplierPartyName = supplier.name;
            commit("setAsset", res);
            const orderAssetServices = getOrderAssetServices(orders[index].orderAssets[0].orderAssetServices);
            orders[index].orderAssets[0] = convertProductAssetToOrderAsset(res, orders[index]);
            orders[index].orderAssets[0].orderAssetServices = orderAssetServices;
            orders[index].orderAssets[0].config.assetDeliveryModel = assetDeliveryModel;
            orders[index].orderAssets[0].config.formBind.supplier = supplier;
            orders[index].orderAssets[0].config.supplierPartyName = supplier.name;
            orders[index].orderAssets[0].config.proposalAssetCalculated.product.assetMargin = res.amountWoTax?.amount - (res.purchaseAmountWoTax?.amount || 0) || 0;
            const unitaryPrice = orders[index].orderAssets[0].config.proposalAssetCalculated.product.unitaryPrice || 0;
            const assetMargin = orders[index].orderAssets[0].config.proposalAssetCalculated.product.assetMargin || 0;
            orders[index].orderAssets[0].config.proposalAssetCalculated.product.assetMarginRate = unitaryPrice > 0 ? ((assetMargin / unitaryPrice) * 100) : 0;
            orders[index].orderAssets[0].assetMarginRate = orders[index].orderAssets[0].config.proposalAssetCalculated.product.assetMarginRate;
            orders[index].orderAssets[0].config.proposalAssetCalculated.product.discountAmount = 0;
            orders[index].orderAssets[0].config.proposalAssetCalculated.product.discount = 0;
            orders[index].orderAssets[0].config.proposalAssetCalculated.product.purchaseAmountWoTax = res.purchaseAmountWoTax?.amount || 0;
            orders[index].orderAssets[0].config.proposalAssetCalculated.product.purchaseAmountWTax = res.purchaseAmountWTax?.amount || 0;
            orders[index].orderAssets[0].bonus = { amount: 0, currency: "EUR" };
            orders[index].orderAssets[0].bbProvision = { amount: 0, currency: "EUR" };
            orders[index].orderAssets[0].tradeInCommitment = { amount: 0, currency: "EUR" };
            orders[index].orderAssets[0].cee = { amount: 0, currency: "EUR" };
            if (productName) {
              orders[index].orderAssets[0].description = productName;
            }
            store.state.orderModule.tempSelectedOrderGoods && store.state.orderModule.tempSelectedOrderGoods.inventory_item_code
              ? (orders[index].orderAssets[0].inventoryItemCode = store.state.orderModule.tempSelectedOrderGoods.inventory_item_code)
              : null;
            commit("setOrders", orders);

            const assetDeliveryModelNew = await convertAssetDeliveryModel(orders, order);
            commit("setAssetDeliveryModel", assetDeliveryModelNew);
            if (payload.callback) {
              payload.callback(res);
            }
          })
          .catch((e: any) => {
            console.error(e);
          });
      }
    },
    getAdditionalInformation({ commit }, payload) {
      const { filter, callback } = payload;
      getAdditionalInformation(filter)
        .then((res) => {
          callback(res);
        })
        .catch((e) => console.error(e));
    },
    addNewProposalAssetItem({ state, commit }, payload) {
      const { type, index } = payload;
      const proposalAsset = state.orders[index].orderAssets[0];
      const orderAssetComponent = deepClone(store.getters["orderModule/getOrderAssetComponentInit"]);
      orderAssetComponent.config.reference = (Math.random() + 1).toString(36).substring(7);
      orderAssetComponent.type = type;
      proposalAsset.orderAssetComponents.unshift(orderAssetComponent);
      commit("setProposalAssetByIndex", { proposalAsset, index });
      commit("setOrders", state.orders);
    },
    updateProposalAssetItem({ commit }, payload) {
      commit("updateProposalAssetItem", payload);
    },
    async removeProposalAssetItem({ commit }, payload) {
      commit("removeProposalAssetItem", payload);
      commit("setDisableSave", true);
      const order = await refreshCommisions();
      commit("setOrder", order);
      commit("setDisableSave", false);
    },
    async calculateOrderProposalAsset({ commit }, payload) {
      const { index, created } = payload;
      const proposalAsset = this.state.orderModule.orders[index].orderAssets[0];
      if (proposalAsset) {
        await calculateProposalAsset(proposalAsset);
        commit("setProposalAssetByIndex", { proposalAsset, index });
      }
      if (!created) {
        commit("setDisableSave", true);
        const order = await refreshCommisions();
        commit("setOrder", order);
        commit("setDisableSave", false);
      }
    },

    async changeProposalAssetItem({ commit }, payload) {
      if (payload) {
        commit("setDisableSave", true);

        const order = await refreshCommisions();
        if (order) {
          commit("setOrder", order);
          Notify.create({
            message: i18n.global.t("order.messages.RefreshCommissionsSuccess"),
            color: "positive",
            timeout: 20000,
          });
        }

        commit("setDisableSave", false);
      }
    },
    calculateProposalAsset({ state, commit }) {
      const proposalAsset = state.orders[0].orderAssets[0];
      calculateProposalAsset(proposalAsset);
      commit("setProposalAssetByIndex", { proposalAsset });
    },
    setProposalAssetByIndex({ state, commit }) {
      const proposalAsset = state.asset;
      commit("setProposalAssetByIndex", { proposalAsset });
    },
    async calculateProposalAssetItem({ state, commit }, payload) {
      const { index, proposalAssetItem } = payload;
      const proposalAsset = state.orders[index].orderAssets[0];
      calculateProposalAsset(proposalAsset);
      commit("updateProposalAssetItem", { proposalAssetItem, index });
      commit("setDisableSave", true);
      const order = await refreshCommisions();
      commit("setOrder", order);
      commit("setDisableSave", false);
    },
    assetCustom({ commit }, payload) {
      const { filter, callback } = payload;
      getAssetCustom(filter)
        .then((res) => {
          callback(res.items);
        })
        .catch((e) => console.error(e));
    },

    assetTax({ commit }, payload) {
      const { callback } = payload;
      getassetTax()
        .then((res) => {
          callback(res.items);
        })
        .catch((e) => console.error(e));
    },
    setOrderItemStatus({ commit }, payload) {
      commit("setOrderItemStatus", payload);
    },
    setPreConditionValid({ commit }, payload) {
      commit("setPreConditionValid", payload);
    },
    setCheckValid({ commit }, payload) {
      commit("setCheckValid", payload);
    },
    setOrderStatus({ commit }, payload) {
      commit("setOrderStatus", payload);
    },
    cleanState({ state, commit }) {
      commit("setInitial");
      this.dispatch("demandModule/cleanState");
      this.dispatch("printDocumentModule/cleanState");
      this.dispatch("orderPartyModule/cleanState");
      if (state.order.orderFinancingModule) {
        this.dispatch("orderFinancingModule/cleanState");
      }
    },
    searchOrder({ commit }, payload) {
      const { filter, offset, limit, callback } = payload;
      searchOrder(filter, offset, limit)
        .then((response) => callback(response))
        .catch((e) => console.error(e));
    },
    searchOrderDeliverySchedule({ commit }, payload) {
      const { filter, offset, limit, callback } = payload;
      searchOrderDeliverySchedule(filter, offset, limit)
        .then((response) => callback(response))
        .catch((e) => console.error(e));
    },
    searchOrderDocumentsMove({ commit }, payload) {
      const { filter, callback } = payload;
      getDocumentsMove(filter)
        .then((response) => callback(response))
        .catch((e) => console.error(e));
    },
    changeAssetReadOnly({ commit }, payload) {
      commit("setAssetReadOnly", payload);
    },
    getOrderGatheringInfo({ state, commit }, payload) {
      const { callback } = state.order.resourceUid;
      getProcess(state.order.resourceUid)
        .then((response) => callback(response))
        .catch((e) => console.error(e));
      commit("setOrderGatheringInfo", payload);
    },
    changePreconditionReadOnly({ commit }, payload) {
      commit("changePreconditionReadOnly", payload);
    },
    getOrderHistory({ commit, state }, { orderId }: { orderId?: string } = {}) {
      const resourceUid = orderId || state.order?.resourceUid;
      if (!resourceUid) return;

      getOrderTaskHistory(resourceUid)
        .then(async (response) => {
          const history = handleOrderHistory(response);
          commit("setHistoriesStep", history);
        })
        .catch((err) => {
          console.error(err);
          Notify.create({
            message: err,
            color: "negative",
          });
        });
    },
    setOrderVariablesVisible({ commit }, payload) {
      commit("setOrderVariablesVisible", payload);
    },

    setOrderDetailPreconditionVisible({ commit }, payload) {
      commit("setOrderDetailPreconditionVisible", payload);
    },
    setOrderDetailPrecondition({ commit }, payload) {
      commit("setOrderDetailPrecondition", payload);
    },
    setOrderStatusHistoryVariablesSelected({ commit }, payload) {
      commit("setOrderStatusHistoryVariablesSelected", payload);
    },
    initSelectedAssetFrom({ commit, getters }) {
      const selectedAssetFrom = getters.getSelectedAssetFromInit;
      commit("setSelectedAssetFrom", selectedAssetFrom);
    },
    initSelectedProductAsset({ commit, getters }) {
      const slectedProductAsset = getters.getSlectedProductAssetInit;
      commit("setSlectedProductAsset", slectedProductAsset);
    },
    updateTempSelectedOrderGoods({ commit }, tempSelectedOrderGoods) {
      commit("updateTempSelectedOrderGoods", tempSelectedOrderGoods);
    },
    SetSelectedSearchOrder({ commit }, payload) {
      commit("SetSelectedSearchOrder", payload);
    },
    SetSelectedSearchOrderItem({ commit }, payload) {
      commit("SetSelectedSearchOrderItem", payload);
    },
    setSlectedProductAsset({ commit }, payload) {
      commit("setSlectedProductAsset", payload);
    },
    updateInventoryItem({ commit }, payload) {
      const { inventoryItemCode, status } = payload;
      getInventoryItem(inventoryItemCode)
        .then((res) => {
          updateInventoryItem(res.data, status, inventoryItemCode)
            .then((res) => {
              console.log("res ", res.data);
            })
            .catch((e) => {
              console.error(e);
            });
        })
        .catch((e) => {
          console.error(e);
        });
    },
    getProduct({ commit }, payload) {
      const { productCode, callback } = payload;
      getProductFeature(productCode)
        .then((res: any) => {
          const selectedProduct = {
            id: res.resourceUid,
            label: res.resourceUid,
            config: {
              resourceUid: res.resourceUid,
              productUid: {
                objectType: res.objectType,
                systemUid: res.systemUid,
                resourceUid: res.resourceUid,
              },
              productName: res.name,
              productReference: res.reference,
              productStatus: res.status,
              classifications: res.classifications,
            },
          };
          callback(selectedProduct);
        })
        .catch((e) => {
          console.error(e);
        });
    },
    gatheringProcessOrder: ({ commit }, payload) => {
      const { request } = payload;
      const configuration = store.state?.orderModule?.order?.orderNetworks?.network?.resourceUid?.id;
      const env = configuration === "PEUGEOT" ? "GEMY" : "BODEMER";
      if (request.gatheringProcess) {
        request.gatheringProcess.sort((a: any, b: any) => {
          if (env === "BODEMER") {
            return PreconditionAction.indexOf(a.assessmentContext) - PreconditionAction.indexOf(b.assessmentContext);
          } else if (env === "GEMY") {
            return PreconditionActionGemy.indexOf(a.assessmentContext) - PreconditionActionGemy.indexOf(b.assessmentContext);
          }
          return 0;
        });
      }
      commit("setGatheringProcessOrder", request.gatheringProcess);
    },
    async hydrateDocuments({ state, commit }, { documentFrom, documentTo }) {
      const gatheringProcessOrder = state.gatheringProcessOrder || [];

      if (!Array.isArray(gatheringProcessOrder) || gatheringProcessOrder.length === 0) {
        return;
      }
      let pFromIndex = -1;
      let pToIndex = -1;
      let gpFromIndex = -1;
      let gpToIndex = -1;

      for (let i = 0; i < gatheringProcessOrder.length; i++) {
        const gp = gatheringProcessOrder[i];
        if (!gp || !Array.isArray(gp.checkpoints) || gp.checkpoints.length === 0) {
          continue;
        }

        for (let j = 0; j < gp.checkpoints.length; j++) {
          const cp = gp.checkpoints[j];
          if (!cp || !cp.document || !cp.document.documentType) {
            continue;
          }

          if (cp.document.documentType === documentTo?.id) {
            pToIndex = i;
            gpToIndex = j;
            continue;
          }

          if (cp.document.documentType === documentFrom?.document.documentType) {
            pFromIndex = i;
            gpFromIndex = j;
            continue;
          }
        }
      }

      if (pToIndex !== -1 && gpToIndex !== -1) {
        // Hydrate actions array
        gatheringProcessOrder[pToIndex].checkpoints[gpToIndex].document = {
          documentUpload: {
            format: "",
            originalFileName: documentFrom.document.documentUpload.originalFileName,
            resourceUid: documentFrom.document.documentUpload.resourceUid,
            objectType: "odm.filemngt.filedescriptor",
            systemUid: "odm-filemngt",
          },
          creationDate: documentFrom.document.creationDate,
          status: "QUALIFIED",
          comment: documentFrom.document.comment,
          typeJustify: documentFrom.document.typeJustify,
          mandatory: documentTo.config.mandatory,
          documentType: documentTo.config.documentType,
          processResourceUid: documentTo.config.processResourceUid,
          receivedFilesUid: documentFrom.document.receivedFilesUid,
          whoModified: documentFrom.document.whoModified,
          whenModified: documentFrom.document.whenModified,
        };
      }

      if (pFromIndex !== -1 && gpFromIndex !== -1) {
        gatheringProcessOrder[pFromIndex].checkpoints[gpFromIndex].document = {
          documentUpload: null,
          creationDate: "",
          status: "PENDING",
          comment: "",
          typeJustify: documentFrom.document.typeJustify,
          mandatory: documentFrom.document.mandatory,
          documentType: documentFrom.document.documentType,
          processResourceUid: documentFrom.document.processResourceUid,
          receivedFilesUid: "",
          whoModified: "",
          whenModified: "",
        };
      }

      if (pToIndex !== -1 && gpToIndex !== -1) {
        //   Hydrate documents array
        gatheringProcessOrder[pToIndex].checkpoints[gpToIndex].documents = [
          {
            ...gatheringProcessOrder[pFromIndex].checkpoints[gpFromIndex].documents[0],
            documentType: documentTo.id,
            mandatory: documentTo.config.mandatory,
            typeJustify: documentTo.config.typeJustify,
            processResourceUid: documentTo.config.processResourceUid,
          },
        ];
      }

      if (pFromIndex !== -1 && gpFromIndex !== -1) {
        gatheringProcessOrder[pFromIndex].checkpoints[gpFromIndex].documents = [
          {
            documentUpload: null,
            creationDate: "",
            status: "PENDING",
            comment: "",
            typeJustify: documentFrom.document.typeJustify,
            mandatory: documentFrom.document.mandatory,
            documentType: documentFrom.document.documentType,
            processResourceUid: documentFrom.document.processResourceUid,
            receivedFilesUid: "",
            whoModified: "",
            whenModified: "",
          },
        ];
      }

    },
    async hydrateDocumentsAndActions({ state, commit }, payload) {
      try {
        // reevaluate=true (sent on order save) re-runs the field/BR checkpoint assessment;
        // on a plain load it stays false so reads are cheap and never write.
        const reevaluate = payload?.reevaluate === true;
        commit("setDocumentsActionsLoading", true);
        commit("setGatheringProcessOrder", []);
        const order: any = state.order as any;
        const orderId = order?.resourceUid;
        const processes = order?.orderGatheringProcess || [];
        if (!orderId || !Array.isArray(processes) || processes.length === 0) {
          return;
        }
        const { getRequiredDocumentValidatedByBRBatch, getProcessOrch } = await import("@/store/services/task/actions/uploadDocumentService");
        const { processDocumentsOrderTab } = await import("@/commons/gathering-process-order");
        const { getAdditionalInformationBatch } = await import("@/store/services/picklist");

        const processIds = processes
          .map((gp: any) => gp?.gatheringProcess?.resourceUid)
          .filter(Boolean) as string[];

        if (processIds.length === 0) return;

        const batchValidated = await getRequiredDocumentValidatedByBRBatch(processIds, orderId, "orderModule", reevaluate);

        const fullProcesses: Array<{ fullProcess: any; requiredDocumentsValidated: any[] }> = [];
        const checkpointIds: string[] = [];

        const processPromises = processes.map(async (gp: any) => {
          const processId = gp?.gatheringProcess?.resourceUid;
          if (!processId) return null;

          const requiredDocumentsValidated = batchValidated[processId] || [];
          let fullProcess = reevaluate ? null : gp?.gatheringProcess?.rawData;
          if (!fullProcess) {
            try {
              if (requiredDocumentsValidated && requiredDocumentsValidated.length) {
                normalizeSupportingType(requiredDocumentsValidated);
              }
              fullProcess = await getProcessOrch(processId, orderId, requiredDocumentsValidated);
            } catch (e) {
              console.error("Failed to fetch orchestrated process", e);
              return null;
            }
          }

          const items = fullProcess?.gatheringProcessItem?.[0]?.items || [];
          const itemCheckpointIds: string[] = [];
          for (const it of items) {
            if (it?.resourceUid && (it?.objectType?.includes("fieldvalue") || it?.objectType?.includes("businessrulevalue"))) {
              itemCheckpointIds.push(it.resourceUid);
            }
          }

          return { fullProcess, requiredDocumentsValidated, itemCheckpointIds };
        });

        const results = await Promise.all(processPromises);
        for (const result of results) {
          if (result) {
            fullProcesses.push(result);
            checkpointIds.push(...result.itemCheckpointIds);
          }
        }

        let additionalInfoMap: Map<string, any> | undefined = undefined;
        try {
          const rows = await getAdditionalInformationBatch(Array.from(new Set(checkpointIds)));
          additionalInfoMap = new Map<string, any>();
          for (const row of rows || []) {
            if (row && row.checkpointid) additionalInfoMap.set(row.checkpointid, row);
          }
        } catch (e) {
          console.error("getAdditionalInformationBatch error", e);
        }

        for (const { fullProcess, requiredDocumentsValidated } of fullProcesses) {
          const supportingDocuments = fullProcess?.supportingDocuments || [];
          const receivedFiles = fullProcess?.gatheringProcessItem?.[0]?.receivedFiles || [];

          // Process with VALIDATED documents
          // Both Actions and Documents tabs use the same data structure
          await processDocumentsOrderTab({
            gatheringProcess: fullProcess,
            requiredDocuments: requiredDocumentsValidated,
            supportingDocuments,
            receivedFiles,
            module: "orderModule",
            additionalInfoMap,
          });
        }
        // Mirror orderModule gatheringProcessOrder into taskModule to keep
        // upload/remove flows (which rely on taskModule) functional in order/detail
        const mirrored = store.state.orderModule.gatheringProcessOrder || ([] as any);
        store.commit("taskModule/setGatheringProcessOrder", mirrored);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("hydrateDocumentsAndActions error", e);
      } finally {
        commit("setDocumentsActionsLoading", false);
      }
    },
    updateAssetDelivery({ state, commit }, payload) {
      const { value, field, index } = payload;
      if (field === "initialDeliveryDate") {
        state.orders[index].orderAssets[0].assetDelivery.initialDeliveryDate = value;
        state.orders[index].initialDeliveryDate = value;
        commit("setOrders", state.orders);
      }
      if (field === "effectiveDeliveryDate") {
        state.orders[index].orderAssets[0].assetDelivery.effectiveDeliveryDate = value;
        state.orders[index].effectiveDeliveryDate = value;
        commit("setOrders", state.orders);
      }
      if (field === "previsionDeliveryDate") {
        state.orders[index].orderAssets[0].assetDelivery.previsionDeliveryDate = value;
        state.orders[index].previsionDeliveryDate = value;
        commit("setOrders", state.orders);
      }
    },
    async setGoodProposalItemFields({ commit }, payload) {
      const { resourceUid, index, type, callback } = payload;
      const goodProposalItem = await getGoodProposalItem(resourceUid);
      if (callback) {
        callback(goodProposalItem);
      }
    },
    deleteEvent({ commit }, payload) {
      commit("deleteEvent", payload);
    },
    setOrderCommissions({ commit }, payload) {
      commit("setOrderCommissions", payload);
    },
    deleteOrderCommission({ commit }, payload) {
      commit("deleteOrderCommission", payload);
    },
    async selectGoodImage({ commit }, payload) {
      const { productUid, callback } = payload;
      console.log("payload ", payload);
      const goodImage = await selectGoodImage(productUid);
      if (callback) {
        callback(goodImage);
      }
    },
    setselectedGoodImage({ state, commit }, payload) {
      const { index, goodImage } = payload;
      state.orders[index].orderAssets[0].config.selectedGoodImage = goodImage;
    },
    updateOrderItem({ commit }, payload) {
      const { orderItemResourceUid, previsionDeliveryDate, color, customerAppointmentDate, Delivery } = payload;
      getOrderItem(orderItemResourceUid)
        .then((orderItem) => {
          updateOrderItem(orderItem.data, previsionDeliveryDate, orderItemResourceUid, color, customerAppointmentDate, Delivery)
            .then((updatedOrderItem) => {})
            .catch((e) => {
              console.error(e);
            });
        })
        .catch((e) => {
          console.error(e);
        });
    },
async updateOrderDateItem({ commit }, payload) {
  const { orderItemResourceUid, previsionDeliveryDate } = payload;

  try {
    const orderItem = await getOrderItem(orderItemResourceUid)
    await updateDateOrderItem(orderItem.data, previsionDeliveryDate, orderItemResourceUid)
  } catch(e) {
    throw e
  }
},
    getOrderStatus({ commit }, payload) {
      const { filter, callback } = payload;
      getOrderStatusProgress(filter)
        .then((res) => {
          callback(res);
        })
        .catch((e) => console.error(e));
    },
    async getOrder({ state, commit }, payload) {
      const { orderResourceUid, callback } = payload;

      const order = await getOrder(orderResourceUid);

      if (callback) {
        callback(order);
      }
    },
    createProductCategoryClass({ commit }, payload) {
      const { parentResourceUid, body, callback } = payload;
      createProductCategoryClass(parentResourceUid, body)
        .then((response) => {
          callback(response);
        })
        .catch((err) => {
          console.error(err);
          Notify.create({
            message: err,
            color: "negative",
          });
        });
    },
    updateOrderStatus({ commit }, payload) {
      const { orderResourceUid, status } = payload;
      const orderStatus = {
        status: status,
      };
      updateOrderStatus(orderResourceUid, orderStatus)
        .then((response) => {
          console.log("response ", response);

        })
        .catch((e) => {
          console.error(e);
        });
    },
    getAlertReasons({ commit }, payload) {
      const { callback } = payload;
      getAlertReasons()
        .then((res) => {
          callback(res);
        })
        .catch((e) => console.error(e));
    },
    getOrderAlertList({ commit }, payload) {
      const { filter, callback } = payload;

      getOrderAlertList(filter)
        .then((res) => {
          const alertList = buildAlertList(res);
          commit("setOrderAlertList", alertList);
          if (callback) {
            callback(alertList);
          }
        })
        .catch((e) => console.error(e));
    },
    getSelectedOrdersAlertList({ commit }, payload) {
      const { filter, callback } = payload;
      commit("setSelectedOrdersAlertList", []);
      getOrderAlertList(filter)
        .then((res) => {
          const selectedOrdersAlertList = buildAlertList(res);
          const notDeletetdAlerts = selectedOrdersAlertList
            ? selectedOrdersAlertList
                .filter((alert: any) => alert && alert.alertValidity && alert.alertValidity.until === null)
                .map((item: any) => ({
                  ...item,
                  selected: item.selected ?? false,
                }))
            : [];
          commit("setSelectedOrdersAlertList", notDeletetdAlerts);
          if (callback) {
            callback(selectedOrdersAlertList);
          }
        })
        .catch((e) => console.error(e));
    },
    setSelectedOrdersAlertList({ commit }, payload) {
      commit("setSelectedOrdersAlertList", payload);
    },
    setSlectedOrdersAlertLoading({ commit }, payload) {
      commit("setSlectedOrdersAlertLoading", payload);
    },
    async addPartieToOrders({ state, dispatch }, payload) {
      const { orders, newParty, roleType } = payload;
      let failedCount = 0;
      for (const or of orders) {
        try {
          const currentOrder = await getOrderOrchestration(or.orderid);
          const cloneCurrentOrder = deepClone(currentOrder);
          const cloneNewParty = deepClone(newParty);
          await addPartieToOrders(cloneCurrentOrder, cloneNewParty, roleType);
        } catch (e) {
          console.error(e);
          failedCount++;
        }
      }

      if (failedCount < orders.length) {
        Notify.create({
          message: i18n.global.t("order.messages.updateSuccess"),
          color: "positive",
        });
      }

      if (failedCount > 0) {
        Notify.create({
          message: i18n.global.t("order.messages.addPartyFailed", {
            count: failedCount,
          }),
          color: "negative",
        });
      }
    },
    setNewParty({ commit }, payload) {
      commit("setNewParty", payload);
    },
    setDeliveryFilter({ commit }, payload) {
      const { filter } = payload;
      commit("setDeliveryFilter", filter);
    },
    setVisibleColumns({ commit }, payload) {
      const { visibleColumns } = payload;
      commit("setVisibleColumns", visibleColumns);
    },
    recoverState({ commit }, payload) {
      const orderResourceUid = localStorage.getItem(globalConfig.storageKeys.orderModule);
      if (orderResourceUid) {
        const orderuid = JSON.parse(orderResourceUid).resourceUid;
        if (orderuid) {
          store.dispatch("orderModule/initOrderEditMode", {
            resourceUid: orderuid,
          });
        }
      }
    },
    setPreviousRoute({ commit }, payload) {
      const { previousRoute } = payload;
      commit("setPreviousRoute", previousRoute);
    },
    setFromRoute({ commit }, payload) {
      const { fromRoute } = payload;
      commit("setFromRoute", fromRoute);
    },
    sendMailWithDocument({ commit }, payload) {
      const { emailSendList, attachment, fileReference } = payload;
      sendMailWithDocument(emailSendList, attachment, fileReference)
        .then((res) => {
          Notify.create({
            message: i18n.global.t("order.messages.mailsended"),
            color: "positive",
          });
        })
        .catch((e) => console.error(e));
    },
    sendMailICSWithDocument({ commit }, payload) {
      const { emailSendList, attachment, fileReference, event } = payload;
      sendMailICSWithDocument(emailSendList, attachment, fileReference, event)
        .then((res) => {
          Notify.create({ message: i18n.global.t("order.messages.mailsended"), color: "positive" });
        })
        .catch((e) => console.error(e));
    },
    createOrderPlanning({ commit }, payload) {
      const { body, orderId } = payload;
      console.log("createOrderPlanning");
      saveOrderPlanning(body, orderId)
        .then((res) => {
          return res;
        })
        .catch((e) => console.error(e));
    },
    getAssignedUser({ commit }, payload) {
      const { filter, callback } = payload;
      getAssignedUser(filter)
        .then((res) => {
          callback(res);
        })
        .catch((e) => console.error(e));
    },
    getScannedDoc: ({ commit }, payload) => {
      const { request, callback } = payload;
    },
    setOrderToDelivery({ commit }, payload) {
      const { order, callback } = payload;
      commit("setOrderToDelivery", order);
    },
    async getActeursEmailListOption({ commit }, payload) {
      const { entity, entityType } = payload;
      await getActeursEmailListOption(entity, entityType)
        .then((response) => {
          if (response.items.length > 0) {
            commit("setActeursEmailListOption", response);
          } else {
            Notify.create({
              message: "No emails found.",
              color: "negative",
            });
          }
        })
        .catch((err) => {
          console.error(err);
          Notify.create({
            message: err.message || err.error || err,
            color: "negative",
          });
        });
    },
    getUserTeamCdvSecretary({ commit }, payload) {
      const { callback } = payload;
      return getUserTeamCdvSecretary()
        .then((res) => {
          callback(res);
        })
        .catch((e) => console.error(e));
    },
    setIsSaving({ commit }, payload) {
      commit("setIsSaving", payload);
    },
    async getOrderDeletedDocuments({ commit }, payload) {
      const { filter, callback } = payload;
      await getDeletedDocumentsInfo(filter)
        .then(async (res) => {
          commit("setOrderDeletedDocuments", res);
        })
        .catch((e) => console.error(e));

    },
    async createOrderDeletedDocument({ commit }, payload) {
      const { orderResourceUid, fileResourceUid } = payload;
      const authName = store.getters["authModule/getAuthName"];
      const createdAt = moment().format("YYYY-MM-DD HH:mm:ss");
      const body = {
        objectType: "odm.order.orderdeleteddocuments",
        systemUid: "odm-order",
        createdBy: authName,
        createdAt: createdAt,
        file: {
          objectType: "odm.filemngt.filedescriptor",
          systemUid: "odm-filemngt",
          resourceUid: fileResourceUid,
        },
      };
      await createOrderDeletedDocument(body, orderResourceUid)
        .then((res) => {
          return res;
        })
        .catch((e) => console.error(e));
    },
    async updateRecievedFile({ commit }, payload) {
      const { request, callback } = payload;
      await updateRecievedFile(request?.file, request?.document?.processResourceUid, request?.document?.receivedFilesUid)
        .then((res: any) => {
          // Update store only (no refetch): reflect comment change in both slices
          const processUid = request?.document?.processResourceUid;
          const receivedFilesUid = request?.document?.receivedFilesUid;
          const newComment = request?.file?.receivedComment || "";
          const newStatus = request?.file?.status?.resourceUid || "";

          const syncCommentAndStatus = (processes: any[]) => {
            for (const process of processes || []) {
              if (process?.resourceUid !== processUid) continue;
              for (const cp of process.checkpoints || []) {
                if (!cp?.objectType?.includes("documentvalue") || !Array.isArray(cp.documents)) continue;
                for (const doc of cp.documents) {
                  if (doc?.receivedFilesUid === receivedFilesUid) {
                    doc.receivedComment = newComment;
                    if (newStatus) {
                      doc.status = newStatus;
                    }
                    // keep Actions row shortcut in sync
                    if (cp.document && cp.document.receivedFilesUid === receivedFilesUid) {
                      cp.document.receivedComment = newComment;
                      if (newStatus) {
                        cp.document.status = newStatus;
                      }
                    }
                  }
                }
              }
            }
          };

          // Update taskModule live list
          syncCommentAndStatus(store.state.taskModule.gatheringProcessOrder);
          // Mirror to orderModule so tabs update
          this.dispatch("orderModule/gatheringProcessOrder", {
            request: { gatheringProcess: store.state.taskModule.gatheringProcessOrder },
          });

          Notify.create({
            message: i18n.global.t("main.dialog.success", { entity: res.data?.resourceUid }),
            color: "positive",
          });
          callback(res);
        })
        .catch((e: any) => console.error(e));
    },
    async singingDocuments({ commit }, payload) {
      const { signingType, selectedDocuments, acteurInfo, signingMode } = payload;
      await singingDocuments(signingType, selectedDocuments, acteurInfo, signingMode)
        .then((res) => {
          Notify.create({ message: i18n.global.t("order.messages.mailsended"), color: "positive" });
          // Signature électronique : l'event esign (et son lien de signature) est créé de façon
          // asynchrone (signingFile → esign → mail → contactmechanism), avec un délai variable.
          // On poll les emailEvents jusqu'à ce que les documents signés y apparaissent, ce qui
          // active en temps réel le bouton "À vous de signer" (openSignatureProcess) sans avoir
          // à quitter/revenir sur l'écran.
          if (signingType === "Elec") {
            const reference = store.state.orderModule.order?.reference
              || store.state.taskModule?.order?.reference;
            if (reference) {
              const targetUids = (selectedDocuments || [])
                .map((d: any) => (d?.receivedFilesUid ? String(d.receivedFilesUid) : null))
                .filter(Boolean) as string[];
              const maxAttempts = 15; // ~45s (15 × 3s) pour couvrir la propagation asynchrone
              const pollEmailEvents = async (attempt: number) => {
                await store.dispatch("messagingModule/fetchEmailEvents", { reference });
                const resolved = collectSignatureReceivedFileUids(store.getters["messagingModule/getEmailEvents"]);
                const allResolved = targetUids.every((uid) => resolved.has(uid));
                // On continue le polling tant qu'il reste des documents cibles non rattachés à un event
                if (targetUids.length > 0 && !allResolved && attempt < maxAttempts) {
                  setTimeout(() => pollEmailEvents(attempt + 1), 3000);
                }
              };
              pollEmailEvents(1);
            }
          }
        })
        .catch((e) => console.error(e));
    },
    subsidiesRecalculate({ commit }, payload) {
      const { order, callback } = payload;
      const newSubsidies = handleSubsidiesRecalculate(order);
      commit("setorderSubvention", newSubsidies);
    },
    changeTab({ commit }, payload) {
      commit("setChangeTab", payload);
    },
    setListOrderParties({ commit, state }, payload) {
      const { orderParties } = payload;
      let ids = new Set(orderParties.map((obj: any) => obj.resourceUid));
      state.order.orderParties = state.order.orderParties.filter((obj: any) => ids.has(obj.resourceUid));
    },
    async confirmBee2Link({ commit }, payload) {
      const { numCmd, networkNodeId, userIpn , userId } = payload;
      try {
        const filter = {
          numContract: numCmd,
        };
        const response = await searchOrderByNumContract(filter);
        console.log(response);
        if (response && response.length > 0) {
          Notify.create({
            message: i18n.global.t("order.messages.orderAlreadyExists"),
            color: 'negative',
          });
          return false;
        }

      } catch (err) {
        console.error(err);
        return false;
      }

      try {
        const res = await confirmBee2Link(numCmd, networkNodeId, userIpn, userId);
        if(res.data.status == 'error'){
          Notify.create({ message: res.data.message, color: "negative", timeout: 20000 });
          return false;
        }else{
          Notify.create({ message: res.data.message, color: "positive", timeout: 20000 });
          return true;
        }
      } catch (e) {
        console.error(e);
        return false;
      }
    },
    removeScannedDocument({ commit }, fileIndex) {
      commit('removeScannedDocument', fileIndex);
    },
    getTypeScale({ commit }, payload) {
      const { filter, callback } = payload;
      getTypeScale(filter)
        .then((res:any) => {
          callback(res);
        })
        .catch((e) => console.error(e));
    },
    updateEmailAddress({ commit }, payload) {
      const { resourceUid, value } = payload;
      setOrderActorContact("emailcontact", resourceUid, { emailAddress: value })
    },
    updatePhoneNumber({ commit }, payload) {
      const { resourceUid, value } = payload;
      setOrderActorContact("phonecontact", resourceUid, { phoneNumber: value })
    }
  },
  mutations: {
    setAssetReadOnly(state, payload) {
      const { readOnly } = payload;
      const { asset } = state;
      asset.config.readOnly = readOnly;
    },
    setOrderVariablesVisible(state, payload) {
      state.variablesVisible = payload;
    },
    setOrderDetailPreconditionVisible(state, payload) {
      state.preConditionDetailVisible = payload;
    },
    setOrderDetailPrecondition(state, payload) {
      state.preConditionDetail = payload;
    },
    setOrderStatusHistoryVariablesSelected(state, payload) {
      state.statusHistoryVariableSelected = payload;
    },
    setOrder(state, payload) {
      state.order = payload;
    },
    removeScannedDocument(state, fileIndex) {
      if (state.order && state.order.orderScannedDocument) {
        state.order.orderScannedDocument.splice(fileIndex, 1);
      }
    },
    setChannel(state, payload) {
      state.order.channel = payload;
    },
    setOrderItem(state, payload) {
      state.orderItem = payload;
    },
    toggleShow(state) {
      state.showAlert = !state.showAlert;
    },
    toggleShowDocumentsHistory(state) {
      state.showDocumentsHistory = !state.showDocumentsHistory;
    },
    toggleShowDeletedAlerts(state) {
      state.showDeletedAlerts = !state.showDeletedAlerts;
    },
    toggleShowOts(state) {
      state.showOts = !state.showOts;
    },
    setOrderAssociatedParty(state, payload) {
      const { party, role, objectType } = payload;
      state.order.orderParties[0].orderParty.party.resourceUid = party;
      state.order.orderParties[0].orderParty.party.objectType = objectType;
      state.order.orderParties[0].orderParty.role.resourceUid = role;
    },

    setSupplier(state, payload) {
      const { asset, orders } = state;
      const { party, objectType, role, name, orderIndex } = payload;
      if (asset) {
        asset.config.formBind.supplier.party = { resourceUid: party, objectType: objectType };
        asset.config.formBind.supplier.role = { resourceUid: role };
        asset.config.formBind.supplier.name = name;
        asset.config.supplierPartyName = name;
      }
      if (orderIndex !== null && orderIndex !== undefined) {
        orders[orderIndex].orderAssets[0].config.formBind.supplier.party = { resourceUid: party, objectType: objectType };
        orders[orderIndex].orderAssets[0].config.formBind.supplier.role = { resourceUid: role };
        orders[orderIndex].orderAssets[0].config.formBind.supplier.name = name;
        orders[orderIndex].orderAssets[0].config.supplierPartyName = name;
        orders[orderIndex].orderAssets[0].supplier = { systemUid: "odm-order" };
        orders[orderIndex].orderAssets[0].supplier.party = { resourceUid: party, objectType: objectType, systemUid: "odm-party" };
        orders[orderIndex].orderAssets[0].supplier.role = { resourceUid: role, systemUid: "odm-order" };
      }
    },
    setNetwork(state, payload) {
      if (state.order?.orderNetworks || state.order?.orderNetworks == "") {
        // EFLO-978 : ne pas ecraser le reseau d'un dossier existant par celui de l'utilisateur connecte
        // (reseau vide = absent, chaine vide ou objet sans id, ex : {id: undefined} au chargement d'un dossier sans reseau)
        const current = state.order?.orderNetworks?.network?.resourceUid;
        const hasNetwork = typeof current === 'string' ? !!current : !!current?.id;
        if (!hasNetwork) {
          state.order.orderNetworks.network.resourceUid = payload;
        }
      }
    },
    setNetworkNode(state, payload) {
      if (state.order?.orderNetworkNodes || state.order?.orderNetworkNodes == "") {
        if (!state.order.orderNetworkNodes.networkNode.resourceUid) {
          state.order.orderNetworkNodes.networkNode.resourceUid = payload;
        }
      }
    },
    setCommercial(state, payload) {
      if (state.order?.assignedSalesPerson || state.order?.assignedSalesPerson == "") {
        state.order.assignedSalesPerson = payload.value;
      }
    },
    setPlaningEvent(state, payload) {
      state.planningDelevry = payload;
    },
    setPlanningNoActorFilter(state, payload) {
      state.planningNoActorFilter = payload;
    },
    selectedDayEvent(state, payload) {
      state.selectedDayEvent = payload;
    },

    changeDateEvent(state, payload) {
      state.selectedEventPlanning.actionStartDate = moment(payload).format("DD/MM/YYYY");
      state.selectedEventPlanning.actionStartHour = moment(payload).format("HH:mm");
      state.selectedEventPlanning.actionEndDate = moment(payload).format("DD/MM/YYYY");
      state.selectedEventPlanning.actionEndHour = moment(payload).add(2, "hour").format("HH:mm");
    },

    setInitial(state) {
      state.orders = [];
      state.mode = OrderModeStatus.CREATE;
      state.index = -1;
      state.order = {};
      state.orderItem = {};
      delete state.asset;
      state.orderFinancingModule.financing = {};
    },
    setAsset(state, payload) {
      console.log("setAsset");
      state.asset = payload;
    },
    setMode(state, payload) {
      state.mode = payload;
    },
    setIndex(state, payload) {
      state.index = payload;
    },
    setOrders(state, payload) {
      state.orders = payload;
    },
    updateProposalAssetItem(state, payload) {
      const { proposalAssetItem, index } = payload;
      const proposalAsset = state.orders[index].orderAssets[0];
      if (proposalAsset.proposalAssetItems) {
        const proposalAssetItemStateIndex = proposalAsset.orderAssetComponents.indexOf(proposalAssetItem);
        proposalAsset.orderAssetComponents[proposalAssetItemStateIndex] = proposalAssetItem;
      }
    },
    changeProposalAssetItem(state, payload) {
      state.checkChangeProposal = payload;
    },
    removeProposalAssetItem(state, payload) {
      const { proposalAssetItem, index } = payload;
      const proposalAsset = state.orders[index].orderAssets[0];
      proposalAsset.orderAssetComponents = (proposalAsset.orderAssetComponents || []).filter((item: any) => {
        const compareResourceUid = !!item.resourceUid && !!proposalAssetItem.resourceUid && item.resourceUid === proposalAssetItem.resourceUid;
        const compareReference = item.config.reference && proposalAssetItem.config.reference && item.config.reference === proposalAssetItem.config.reference;
        const isRemoved = compareResourceUid || compareReference;
        return !isRemoved;
      });
    },
    setProposalAssetByIndex(state, payload) {
      const { proposalAsset } = payload;
      state.asset = proposalAsset;
    },

    setOrderItemStatus(state, payload) {
      state.orderItem.status.resourceUid = payload;
    },
    setPreConditionValid(state, payload) {
      state.preConditionValid = payload;
    },
    setCheckValid(state, payload) {
      state.checkValid = payload;
    },
    setOrderStatus(state, payload) {
      state.order.status.resourceUid = payload;
    },
    setOrderAlertList(state, payload) {
      state.alertList = payload;
    },
    // alerts are saved outside the order payload: keep order.orderAlerts aligned with the DB
    addOrderAlert(state, payload) {
      const { orderId, alert } = payload;
      if (!state.order || !alert || state.order.resourceUid !== orderId) return;
      if (!state.order.orderAlerts) state.order.orderAlerts = [];
      state.order.orderAlerts.push(alert);
    },
    // an alert is not removed but closed (alertValidity.until): keep the store aligned with the DB
    closeOrderAlert(state, payload) {
      const orderAlert = state.order?.orderAlerts?.find((item: any) => item.resourceUid === payload.alertId);
      if (orderAlert?.alertValidity) {
        orderAlert.alertValidity.until = moment(new Date()).format("DD/MM/YYYY");
        orderAlert.businessData = { ...(orderAlert.businessData || {}), deletedBy: payload.deletedBy, deletedAt: payload.deletedAt };
      }
    },
    setSelectedOrdersAlertList(state, payload) {
      state.selectedOrdersAlertList = payload;
    },
    setSlectedOrdersAlertLoading(state, payload) {
      state.selectedOrdersAlertLoading = payload;
    },
    setOrderGatheringInfo(state, payload) {
      state.order.status.resourceUid = payload;
    },
    setHistoriesStep(state, payload) {
      state.historiesStep = payload;
    },
    setSelectedAssetFrom(state, payload) {
      state.selectedAssetFrom = payload;
    },
    setSlectedProductAsset(state, payload) {
      state.selectedProductAsset = payload;
    },
    updateTempSelectedOrderGoods(state, payload) {
      state.tempSelectedOrderGoods = payload;
    },
    setGatheringProcessOrder(state, payload) {
      state.gatheringProcessOrder = payload;
    },
    setDocumentsActionsLoading(state, payload) {
      (state as any).documentsActionsLoading = payload;
    },
    setAssetDeliveryModel(state, payload) {
      state.assetDeliveryModel = payload;
    },
    setAssociatedPartyInfo(state, payload) {
      state.associatedPartyInfo = payload;
    },
    setAssociatedPartymail(state, payload) {
      state.associatedPartymailList = payload;
    },
    deleteEvent(state, payload) {
      const { index } = payload;
      state.planningDelevry?.splice(index - 1, 1);
    },
    setAlertList(state, payload) {
      state.order.alertList = payload;
    },
    setorderSubvention(state, payload) {
      state.order.orderSubsidies = payload;
    },
    SetSelectedSearchOrder(state, payload) {
      state.selectedSearchOrder = payload;
    },
    SetSelectedSearchOrderItem(state, payload) {
      state.selectedSearchOrderItem = payload;
    },
    setSelectedEventPlanning(state, payload) {
      state.selectedEventPlanning = payload;
    },
    setSelectedEventPlanningAssignedUser(state, payload) {
      state.selectedEventPlanning.assignedUser = payload;
    },
    setOrderCommissions(state, payload) {
      state.order.orderCommissions = payload;
    },
    deleteOrderCommission(state, payload) {
      const { index } = payload;
      if (index !== -1) {
        state.order.orderCommissions.splice(index, 1);
      }
    },
    setNewParty(state, payload) {
      state.newParty = payload;
    },
    setDeliveryFilter(state, payload) {
      state.deliveryFilter = payload;
    },
    setVisibleColumns(state, payload) {
      state.visibleColumns = payload;
    },
    setPreviousRoute(state, payload) {
      state.previousRoute = payload;
    },
    setFromRoute(state, payload) {
      state.fromRoute = payload;
    },
    setOrderToDelivery(state, payload) {
      state.orderToDelivery = payload;
    },
    setIsSaving(state, payload) {
      state.isSaving = payload;
    },
    setOrderDeletedDocuments(state, payload) {
      state.deletedDocuments = payload;
    },
    setChangeTab(state, payload) {
      state.changeTab = payload;
    },
    setDisableSave(state, payload) {
      state.disableSave = payload;
    }
  },
  modules: {
    orderFinancingModule: orderFinancingModule,
  },
};

export default orderModule;
